import {
    Home, Map as MapIcon, Pickaxe, Hammer, ArrowUp, Leaf, Store, ShoppingBag,
    Star, Trophy, Book, Zap, ScrollText, Gift, Users, User, ShieldCheck, Wrench, History
, ClipboardList } from 'lucide-react'

// Single source of truth for navigation structure.
// Consumed by the desktop sidebar (Sidebar.jsx) and the mobile More sheet (MobileNav.jsx).

export const PINNED_ITEM = { path: '/shelter', label: 'Shelter', icon: Home }

// Admin-only group: rendered only for users with is_admin (see visibleNavGroups).
export const NAV_GROUPS = [
    {
        key: 'play',
        label: 'Play',
        items: [
            { path: '/scavenging', label: 'Scavenging', icon: MapIcon },
            { path: '/gathering', label: 'Gathering', icon: Pickaxe },
            { path: '/crafting', label: 'Crafting', icon: Hammer },
            { path: '/upgrades', label: 'Upgrades', icon: ArrowUp },
        ],
    },
    {
        key: 'build',
        label: 'Build & Trade',
        items: [
            { path: '/rooms', label: 'Rooms', icon: Leaf },
            { path: '/tech-tree', label: 'Tech Tree', icon: Zap },
            { path: '/vendors', label: 'Vendors', icon: Store },
            { path: '/market', label: 'Market', icon: ShoppingBag, badgeKey: 'market' },
        ],
    },
    {
        key: 'progress',
        label: 'Progress',
        items: [
            { path: '/skills', label: 'Skills', icon: Star },
            { path: '/contracts', label: 'Contracts', icon: ClipboardList },
            { path: '/achievements', label: 'Achievements', icon: Trophy, badgeKey: 'achievements' },
            { path: '/blueprints', label: 'Blueprints', icon: ScrollText },
            { path: '/codex', label: 'Codex', icon: Book },
            { path: '/events', label: 'Events Log', icon: History },
        ],
    },
    {
        key: 'admin',
        label: 'Admin',
        items: [
            { path: '/admin', label: 'Admin', icon: ShieldCheck, adminOnly: true },
        ],
    },
]

// Conditional account entries rendered at the bottom of nav lists.
export const getUserItems = ({ demoModeEnabled, handle } = {}) => {
    const items = [
        { path: '/daily-rewards', label: 'Daily Rewards', icon: Gift, badgeKey: 'daily' },
    ]
    if (demoModeEnabled) {
        items.push({ path: '/characters', label: 'Characters', icon: Users })
        items.push({ path: '/cheat', label: 'Cheat', icon: Wrench })
    }
    if (handle) {
        items.push({ path: `/profile/${handle}`, label: 'View Profile', icon: User })
    }
    return items
}

// Filter out adminOnly items for non-admin users — one config, every surface.
export const filterAdminItems = (items, isAdmin) =>
    items.filter(item => !item.adminOnly || isAdmin)

export const visibleNavGroups = (groups, isAdmin) =>
    groups
        .map(group => ({ ...group, items: filterAdminItems(group.items, isAdmin) }))
        .filter(group => group.items.length > 0)

// Mobile bottom tabs: highest-frequency destinations only.
export const MOBILE_TABS = [
    { path: '/shelter', label: 'Home', icon: Home },
    { path: '/scavenging', label: 'Scav', icon: MapIcon },
    { path: '/crafting', label: 'Craft', icon: Hammer },
    { path: '/rooms', label: 'Rooms', icon: Leaf },
]

export const isPathActive = (path, pathname) => {
    if (path === '/shelter' && pathname === '/') return true
    return pathname === path || pathname.startsWith(path + '/')
}

// Badge visibility lookup: badgeKey -> boolean/count from usePlayerMeta().
export const resolveBadge = (item, badges) => {
    if (!item.badgeKey || !badges) return null
    const value = badges[item.badgeKey]
    if (!value) return null
    return typeof value === 'number' ? { count: value } : { count: 0 }
}
